module.exports = __webpack_public_path__ + "img/空白（订口图）.e7f4e9ea.jpg";